module.exports = __webpack_public_path__ + "img/andrew-cutler-headshot.df003b5a.png";